export const environment = {
  production: true,
  // Feature flags
  FEATURE_LOGIN_BUTTON: false,
};
